<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>转账审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="page-actions">
        <el-select v-model="status" placeholder="状态">
          <el-option value>请选择</el-option>
          <el-option
            v-for="key in Object.keys(STATUS_TYPES)"
            :key="key"
            :label="STATUS_TYPES[key].text"
            :value="key"
          ></el-option>
        </el-select>

        <el-input placeholder="请输入转出ID" v-model="fromUid" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入转入ID" v-model="toUserId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <audit-list @refresh="refreshList($event)"></audit-list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import AuditList from "./components/list";
import { STATUS_TYPES } from './constants';

export default {
  name: "loglim",
  data() {
    return {
      STATUS_TYPES,
      status:'',
      fromUid:'',
      toUserId:''
    };
  },
  components: {
    AuditList 
  },
  computed: {
    ...mapState('transfer', ['pagination'])
  },
  methods: {
    ...mapActions("transfer", ["list"]),
    handleSearch(){
       this.list({status:this.status,fromUid:this.fromUid,toUserId:this.toUserId});
    },
  },
  mounted() {
    this.list();
  }
};
</script>

<style lang="less" scoped></style>
